import type { ModulatorCsId } from "~domain/devices/models/modulators/modulator-model.ts";

import { z } from "zod";

export const backofficeFindModulatorLastTemperaturePointResponseSchema = z
  .object({
    dateMeter: z.coerce.date(),
    idCsModulator: z.number().transform((s) => s as ModulatorCsId),
  })
  .array();

export type BackofficeFindModulatorLastTemperaturePointResponse = z.infer<
  typeof backofficeFindModulatorLastTemperaturePointResponseSchema
>;
